import { Link } from 'react-router-dom';
import { seoArticleData } from '@/mocks/seo-article';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function SeoGuidePage() {
  return (
    <>
      <title>{seoArticleData.title}</title>
      <meta name="description" content={seoArticleData.metaDescription} />
      <link rel="canonical" href="https://vigorbuy.cam/vigorbuy-sheet-seo-guide" />
      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: seoArticleData.title,
        description: seoArticleData.metaDescription,
        datePublished: seoArticleData.publishedDate,
        dateModified: seoArticleData.modifiedDate,
        author: { '@type': 'Organization', name: 'VigorBuy Spreadsheet' },
        publisher: { '@type': 'Organization', name: 'VigorBuy Spreadsheet' },
        mainEntityOfPage: { '@type': 'WebPage', '@id': 'https://vigorbuy.cam/vigorbuy-sheet-seo-guide' },
      })}</script>
      <Navbar />
      <main>
        <article className="pt-28 pb-20">
          <div className="max-w-[860px] mx-auto px-6 md:px-10">
            <nav className="mb-6" aria-label="Breadcrumb">
              <ol className="flex items-center gap-2 text-xs text-foreground-500">
                <li>
                  <Link to="/" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                    Home
                  </Link>
                </li>
                <li>
                  <i className="ri-arrow-right-s-line text-[10px]"></i>
                </li>
                <li className="text-primary-600 font-medium whitespace-nowrap">
                  SEO Guide
                </li>
              </ol>
            </nav>

            <header className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <span className="px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-[11px] font-semibold uppercase tracking-wider">
                  Beginner Guide
                </span>
                <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-[11px] font-semibold uppercase tracking-wider">
                  Updated 2026
                </span>
              </div>
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 tracking-tight leading-tight">
                {seoArticleData.title}
              </h1>
              <div className="flex flex-wrap items-center gap-4 mt-5 text-xs text-foreground-500">
                <span>Published: {seoArticleData.publishedDate}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span>Last Modified: {seoArticleData.modifiedDate}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span>14 min read</span>
              </div>
            </header>

            <div className="mb-12 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20desk%20setup%20with%20laptop%20showing%20colorful%20spreadsheet%20charts%20and%20data%20visualizations%20on%20screen%2C%20warm%20morning%20sunlight%20streaming%20through%20nearby%20window%2C%20productivity%20workspace%20photography%2C%20modern%20professional%20aesthetic%2C%20coffee%20and%20notebook%20accessories%2C%20clean%20organized%20composition%2C%20inspiring%20creative%20work%20environment%20with%20plants&width=1200&height=500&seq=seo-article-hero-v2-2026&orientation=landscape"
                alt="VigorBuy Spreadsheet complete beginner guide"
                className="w-full h-auto"
                title="VigorBuy Spreadsheet (2026): The Complete Beginner Guide to Smarter Shopping"
              />
            </div>

            <div className="prose-custom">
              {seoArticleData.sections.map((section, sIdx) => (
                <section key={sIdx} className="mb-12">
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight mb-5">
                    {section.heading}
                  </h2>
                  {section.content.map((paragraph, pIdx) => (
                    <p
                      key={pIdx}
                      className="text-base text-foreground-700 leading-relaxed mb-4"
                      dangerouslySetInnerHTML={{ __html: paragraph }}
                    ></p>
                  ))}
                </section>
              ))}
            </div>

            <div className="mt-16 pt-10 border-t border-background-200">
              <div className="bg-background-100 rounded-lg p-8 text-center">
                <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">
                  Ready to Start Shopping Smarter?
                </h3>
                <p className="text-sm text-foreground-600 mb-6 max-w-md mx-auto">
                  Explore the latest <strong>VigorBuy Spreadsheet</strong> resources and discover how much easier organized shopping can be.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/"
                    className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
                  >
                    <i className="ri-home-4-line text-base"></i>
                    Back to Homepage
                  </Link>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="px-6 py-3 rounded-md bg-secondary-100 text-secondary-800 text-sm font-semibold hover:bg-secondary-200 transition-colors duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
                  >
                    Visit Main Store
                    <i className="ri-arrow-right-up-line text-base"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}